var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { Layer, Group } from './export';
import { IDBroker, NameGenerator } from '../utils/export';
import { Map, fromJS } from 'immutable';

import { MODE_IDLE, MODE_DRAWING_ITEM, MODE_DRAGGING_ITEM, MODE_ROTATING_ITEM, MODE_RESIZING_ITEM } from '../constants';

var Item = function () {
  function Item() {
    _classCallCheck(this, Item);
  }

  _createClass(Item, null, [{
    key: 'create',
    value: function create(state, layerID, type, x, y, width, height, rotation) {
      var catPage = state.getIn(['catalog', 'page']);
      var itemID = IDBroker.acquireID();
      var stateItems = state.getIn(['scene', 'layers', layerID, 'items']).toJS();
      var count = 1;
      if (stateItems) {
        var items = Object.values(stateItems);
        var onlyFromDb = items.filter(function (r) {
          return r.isFromDb;
        });
        var unique = onlyFromDb.filter(function (v, i, a) {
          return a.findIndex(function (r) {
            return r.type === v.type;
          }) === i;
        });
        count = onlyFromDb.some(function (r) {
          return r.type === type;
        }) ? onlyFromDb.find(function (r) {
          return r.type === type;
        }).productCount : unique.length + 1;
      }

      var item = state.catalog.factoryElement(type, {
        id: itemID,
        name: NameGenerator.generateName('items', state.catalog.getIn(['elements', type, 'info', 'title'])),
        desc: state.catalog.getIn(['elements', type, 'info', 'description']) ? NameGenerator.generateName('items', state.catalog.getIn(['elements', type, 'info', 'description'])) : '',
        type: type,
        height: height,
        width: width,
        x: x,
        y: y,
        rotation: rotation,
        catalogPack: catPage,
        isFromDb: state.catalog.getIn(['elements', type, 'info', 'isFromDb']) ? state.catalog.getIn(['elements', type, 'info', 'isFromDb']) : false,
        productCount: state.catalog.getIn(['elements', type, 'info', 'isFromDb']) ? count : 0,
        floorID: state.getIn(['scene', 'selectedFloor'])
      });

      state = state.setIn(['scene', 'layers', layerID, 'items', itemID], item);

      return { updatedState: state, item: item };
    }
  }, {
    key: 'select',
    value: function select(state, layerID, itemID) {
      state = Layer.select(state, layerID).updatedState;
      state = Layer.selectElement(state, layerID, 'items', itemID).updatedState;

      return { updatedState: state };
    }
  }, {
    key: 'remove',
    value: function remove(state, layerID, itemID) {
      state = this.unselect(state, layerID, itemID).updatedState;
      var count = state.getIn(['scene', 'layers', layerID, 'items', itemID, 'productCount']);
      state = Layer.removeElement(state, layerID, 'items', itemID).updatedState;

      if (state.getIn(['scene', 'layers', layerID, 'items']).filter(function (r) {
        return r.isFromDb;
      }).size > 0 && state.getIn(['scene', 'layers', layerID, 'items']).filter(function (r) {
        return r.productCount === count;
      }).size === 0) {
        var _state$getIn = state.getIn(['scene', 'layers', layerID]),
            items = _state$getIn.items;

        items.forEach(function (item) {
          if (item.productCount > count) {
            var newProdCount = item.productCount - 1;
            state = state.setIn(['scene', 'layers', layerID, 'items', item.id, 'productCount'], newProdCount);
          }
        });
      }

      state.getIn(['scene', 'groups']).forEach(function (group) {
        return state = Group.removeElement(state, group.id, layerID, 'items', itemID).updatedState;
      });

      return { updatedState: state };
    }
  }, {
    key: 'unselect',
    value: function unselect(state, layerID, itemID) {
      state = Layer.unselect(state, layerID, 'items', itemID).updatedState;

      return { updatedState: state };
    }
  }, {
    key: 'selectToolDrawingItem',
    value: function selectToolDrawingItem(state, sceneComponentType) {
      state = state.merge({
        mode: MODE_DRAWING_ITEM,
        drawingSupport: new Map({
          type: sceneComponentType
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateDrawingItem',
    value: function updateDrawingItem(state, layerID, x, y) {
      if (state.hasIn(['drawingSupport', 'currentID'])) {
        state = state.updateIn(['scene', 'layers', layerID, 'items', state.getIn(['drawingSupport', 'currentID'])], function (item) {
          return item.merge({ x: x, y: y });
        });
      } else {
        var _create = this.create(state, layerID, state.getIn(['drawingSupport', 'type']), x, y, 200, 100, 0),
            stateI = _create.updatedState,
            item = _create.item;

        state = Item.select(stateI, layerID, item.id).updatedState;
        state = state.setIn(['drawingSupport', 'currentID'], item.id);
      }

      return { updatedState: state };
    }
  }, {
    key: 'endDrawingItem',
    value: function endDrawingItem(state, layerID, x, y) {
      var catalog = state.catalog;
      state = this.updateDrawingItem(state, layerID, x, y, catalog).updatedState;
      //state = Layer.unselectAll(state, layerID).updatedState;

      state = state.merge({
        mode: MODE_IDLE,
        draggingSupport: null,
        activeSnapElement: null
      });

      return { updatedState: state };
    }
  }, {
    key: 'beginDraggingItem',
    value: function beginDraggingItem(state, layerID, itemID, x, y) {

      var item = state.getIn(['scene', 'layers', layerID, 'items', itemID]);

      state = state.merge({
        mode: MODE_DRAGGING_ITEM,
        draggingSupport: Map({
          layerID: layerID,
          itemID: itemID,
          startPointX: x,
          startPointY: y,
          originalX: item.x,
          originalY: item.y
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateDraggingItem',
    value: function updateDraggingItem(state, x, y) {
      var _state = state,
          draggingSupport = _state.draggingSupport,
          scene = _state.scene;


      var layerID = draggingSupport.get('layerID');
      var itemID = draggingSupport.get('itemID');
      var startPointX = draggingSupport.get('startPointX');
      var startPointY = draggingSupport.get('startPointY');
      var originalX = draggingSupport.get('originalX');
      var originalY = draggingSupport.get('originalY');

      var diffX = startPointX - x;
      var diffY = startPointY - y;

      var item = scene.getIn(['layers', layerID, 'items', itemID]);
      item = item.merge({
        x: originalX - diffX,
        y: originalY - diffY
      });

      state = state.merge({
        scene: scene.mergeIn(['layers', layerID, 'items', itemID], item)
      });

      return { updatedState: state };
    }
  }, {
    key: 'endDraggingItem',
    value: function endDraggingItem(state, x, y) {
      state = this.updateDraggingItem(state, x, y).updatedState;
      state = state.merge({ mode: MODE_IDLE });

      return { updatedState: state };
    }
  }, {
    key: 'beginRotatingItem',
    value: function beginRotatingItem(state, layerID, itemID, x, y) {
      state = state.merge({
        mode: MODE_ROTATING_ITEM,
        rotatingSupport: Map({
          layerID: layerID,
          itemID: itemID
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateRotatingItem',
    value: function updateRotatingItem(state, x, y) {
      var _state2 = state,
          rotatingSupport = _state2.rotatingSupport,
          scene = _state2.scene;


      var layerID = rotatingSupport.get('layerID');
      var itemID = rotatingSupport.get('itemID');
      var item = state.getIn(['scene', 'layers', layerID, 'items', itemID]);

      var deltaX = x - item.x;
      var deltaY = y - item.y;
      var rotation = Math.atan2(deltaY, deltaX) * 180 / Math.PI - 90;

      if (-5 < rotation && rotation < 5) rotation = 0;
      if (-95 < rotation && rotation < -85) rotation = -90;
      if (-185 < rotation && rotation < -175) rotation = -180;
      if (85 < rotation && rotation < 90) rotation = 90;
      if (-270 < rotation && rotation < -265) rotation = 90;

      item = item.merge({
        rotation: rotation
      });

      state = state.merge({
        scene: scene.mergeIn(['layers', layerID, 'items', itemID], item)
      });

      return { updatedState: state };
    }
  }, {
    key: 'endRotatingItem',
    value: function endRotatingItem(state, x, y) {
      state = this.updateRotatingItem(state, x, y).updatedState;
      state = state.merge({ mode: MODE_IDLE });

      return { updatedState: state };
    }
  }, {
    key: 'beginResizingItem',
    value: function beginResizingItem(state, layerID, itemID, x, y, property) {
      state = state.merge({
        mode: MODE_RESIZING_ITEM,
        resizingSupport: Map({
          layerID: layerID,
          itemID: itemID,
          property: property
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateResizingItem',
    value: function updateResizingItem(state, x, y) {
      var _state3 = state,
          resizingSupport = _state3.resizingSupport,
          scene = _state3.scene;

      var propertyString = resizingSupport.get('property');
      var layerID = resizingSupport.get('layerID');
      var itemID = resizingSupport.get('itemID');
      var item = state.getIn(['scene', 'layers', layerID, 'items', itemID]);
      var rotation = item.getIn(['rotation']);
      var length = undefined;
      var _length = undefined;

      if (propertyString === 'width') {
        length = item.getIn(['properties', 'width', 'length']);
        _length = item.getIn(['properties', 'width', '_length']);
      } else {
        length = item.getIn(['properties', 'depth', 'length']);
        _length = item.getIn(['properties', 'depth', '_length']);
      }

      var delta = this.getDeltaByRotation(rotation, item.x, item.y, x, y, length, propertyString);

      if (delta + length > 0) {
        length = length + delta < 50 ? 50 : length + delta;
        if (propertyString === 'width') {
          item = item.setIn(['properties', 'width', 'length'], length);
          if (_length !== undefined && _length !== null) {
            item = item.setIn(['properties', 'width', '_length'], length);
          }
        } else {
          item = item.setIn(['properties', 'depth', 'length'], length);
          if (_length !== undefined && _length !== null) {
            item = item.setIn(['properties', 'depth', '_length'], length);
          }
        }
      }

      state = state.merge({
        scene: scene.mergeIn(['layers', layerID, 'items', itemID], item)
      });

      return { updatedState: state };
    }
  }, {
    key: 'endResizingItem',
    value: function endResizingItem(state, x, y) {
      state = this.updateResizingItem(state, x, y).updatedState;
      state = state.merge({ mode: MODE_IDLE });

      return { updatedState: state };
    }
  }, {
    key: 'getDeltaByRotation',
    value: function getDeltaByRotation(rotation, itemX, itemY, x, y, length, propertyString) {
      var delta = 0;
      if (rotation > -45 && rotation <= 45) {
        if (propertyString === 'width') delta = x - (itemX + length / 2);else delta = itemY - (y + length / 2);
      } else if (rotation > -135 && rotation <= -45) {
        if (propertyString === 'width') delta = itemY - (y + length / 2);else delta = itemX - (x + length / 2);
      } else if (rotation > -225 && rotation <= -135) {
        if (propertyString === 'width') delta = itemX - (x + length / 2);else delta = y - (itemY + length / 2);
      } else {
        if (propertyString === 'width') delta = y - (itemY + length / 2);else delta = x - (itemX + length / 2);
      }

      return delta;
    }
  }, {
    key: 'setProperties',
    value: function setProperties(state, layerID, itemID, properties) {
      state = state.mergeIn(['scene', 'layers', layerID, 'items', itemID, 'properties'], properties);

      return { updatedState: state };
    }
  }, {
    key: 'setJsProperties',
    value: function setJsProperties(state, layerID, itemID, properties) {
      return this.setProperties(state, layerID, itemID, fromJS(properties));
    }
  }, {
    key: 'updateProperties',
    value: function updateProperties(state, layerID, itemID, properties) {
      properties.forEach(function (v, k) {
        if (state.hasIn(['scene', 'layers', layerID, 'items', itemID, 'properties', k])) state = state.mergeIn(['scene', 'layers', layerID, 'items', itemID, 'properties', k], v);
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateJsProperties',
    value: function updateJsProperties(state, layerID, itemID, properties) {
      return this.updateProperties(state, layerID, itemID, fromJS(properties));
    }
  }, {
    key: 'setAttributes',
    value: function setAttributes(state, layerID, itemID, itemAttributes) {
      state = state.mergeIn(['scene', 'layers', layerID, 'items', itemID], itemAttributes);
      return { updatedState: state };
    }
  }, {
    key: 'setJsAttributes',
    value: function setJsAttributes(state, layerID, itemID, itemAttributes) {
      itemAttributes = fromJS(itemAttributes);
      return this.setAttributes(state, layerID, itemID, itemAttributes);
    }
  }]);

  return Item;
}();

export { Item as default };